import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import langEn from 'src/lang/lang.en.json'
const resource = {
  //여기에 추가되는 언어를 작성
  en: {
    translation: langEn,
  },
}

i18n.use(initReactI18next).init({
  resources: resource,
  // 초기 설정 언어
  lng: navigator.language?.substring(0, 2) as string,
  fallbackLng: 'en',
  defaultNS: 'translation',
  ns: 'translation',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export default i18n

// resources: 이 옵션은 i18next에서 사용하는 언어 리소스를 지정합니다.
// 언어 코드를 번역 개체에 매핑하는 개체여야 합니다.
//
//lng: 이 옵션은 i18next의 초기 언어를 설정합니다.
//
//fallbackLng: 이 옵션은 요청한 언어에 대한 번역을 사용할 수 없는 경우 사용할 대체 언어를 지정합니다.
// 언어 코드를 대체 언어 코드 배열에 매핑하는 개체여야 합니다.
//
//debug: 로 설정하면 true이 옵션은 i18next에 대한 디버그 모드를 활성화합니다.
// 디버그 모드에서 i18next는 번역 관련 문제를 디버깅하는 데 유용할 수 있는 추가 정보 및 경고를 콘솔에 출력합니다.
//
//defaultNS: 이 옵션은 번역의 기본 네임스페이스를 지정합니다.
// 네임스페이스는 번역을 다른 논리적 섹션으로 구성하는 방법입니다.
// 코드에서 기본 네임스페이스는 'translation'으로 설정되어 있으므로
// 달리 명시적으로 지정하지 않는 한 모든 번역은 'translation' 네임스페이스에 있어야 합니다.
//
//ns: 이 옵션은 번역에 사용되는 네임스페이스를 설정합니다.
// 코드에서 'translation' 네임스페이스가 사용됩니다.
// 즉, 모든 번역이 'translation' 네임스페이스에서 검색됩니다.
//
//keySeparator: 이 옵션은 번역 키에서 키 구분 기호로 사용되는 문자를 정의합니다.
// 기본적으로 i18next는 키 구분 기호로 점('.')을 사용합니다.
// 그러나 코드에서 false키 구분 기호가 사용되지 않음을 의미하는 로 설정했습니다.
//
//interpolation: 이 옵션은 i18next에 대한 보간 동작을 구성합니다.
// 보간을 사용하면 동적 값을 번역된 문자열에 삽입할 수 있습니다. 이 escapeValue옵션을 로 설정하면 false보간된 값에 대한
// HTML이스케이프가 비활성화됩니다.
//
//react: 이 옵션은 i18next와의 React 통합에 특정한 구성을 제공합니다.
// 코드에서 useSuspense이 로 설정되어 있습니다 false. 이는 번역 로드에 React Suspense를 사용하지 않는다는 의미입니다.
// 로 설정하면 trueReact Suspense를 사용하여 번역 로드 및 폴백 렌더링을 처리할 수 있습니다.
